import { MPFLink } from 'volto-ministerio-publico-federal/components/UI';
import { MobileSidebarSheet } from 'volto-ministerio-publico-federal/components/UI/MobileSidebarSheet';

export interface RelatedItemsProps {
  title: string;
  description: string;
  relatedItems: {
    '@id': string;
    title: string;
  }[];
}

export const RelatedItems = ({
  title,
  description,
  relatedItems,
}: RelatedItemsProps) => {
  return (
    <aside className="mpf-internal-view__sidebar">
      <MobileSidebarSheet label={title}>
        <section className="mpf-internal-view__related">
          <header className="mpf-internal-view__related-header">
            <h2 className="mpf-internal-view__related-title">{title}</h2>
            <p className="mpf-internal-view__related-desc">{description}</p>
          </header>

          <div className="mpf-internal-view__links">
            {relatedItems.map((item) => (
              <MPFLink
                key={item['@id']}
                item={item}
                className="mpf-internal-view__link-item"
              >
                <span className="mpf-internal-view__link-label">
                  {item.title}
                </span>
                <svg
                  aria-hidden="true"
                  className="mpf-internal-view__link-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.75"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M9 18l6-6-6-6" />
                </svg>
              </MPFLink>
            ))}
          </div>
        </section>
      </MobileSidebarSheet>
    </aside>
  );
};
